import { sizeStateType } from './types';
import { ActionTypes }   from '../actions/types';
  
  
  export const initialSizeState: sizeStateType = {
    size:       [0,0],
    wideScreen: true,
    longScreen: true,
    menuSize:   360,
    navBarSize: 82
  }
  
  const sizeReducer = (state = initialSizeState, action: ActionTypes) => {
  
  switch (action.type) {
    
  
  case 'SET_SIZE_STATE':
    {
      const { size } = action.payload;
      const wide = size[0] > 750;
      const long = size[1] > 550;

      return {
          size:       size,
          wideScreen: wide,
          longScreen: size[1] > 550,
          menuSize:   wide ? 360 : size[0],
          navBarSize: (wide && long) ? 82 : wide ? 60 : 50
      }
    }  
  
  
      default: return state;
    }
  };
  
  
  export { sizeReducer };
  